import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import {Consumer} from '../../../../context/Context'
import axios from '../../../../services/AxiosOrders'
import physician01 from '../../../static/physician01.jpg'
import physician02 from '../../../static/physician02.jpeg'
import physician03 from '../../../static/Frost_ Andrei_MD.jpg'
import { Card, Icon, Image , Label, Button} from 'semantic-ui-react'


// similar to Card.js
export default class Project extends Component {
  constructor(props) {
    super(props);
  }


  onDeleteClick = async (id, dispatch, auth) => {
    // await axios.delete(`/cards/${id}.json?auth=${auth.token}`);
    await axios.delete(`${auth.localId}/cards/${id}.json?&auth=${auth.token}`);

    dispatch({ type: 'DELETE_CARD', payload: id });
  };


  onGetClick = async (id, dispatch, auth) => {
    await axios.get(`/cards/${id}.json?auth=${auth.token}`);

    dispatch({ type: 'UPDATE_CARD', payload: id });
  };
  // const resp = await axios.get(`${auth.localId}/cards.json?auth=${auth.token}`);

  onGetClick2 = async (id, dispatch, auth) => {
    // const queryParams = `?auth=${auth.token}&orderBy="userId"&equalTo="${auth.localId}"`;
    await axios.get(`/${auth.localId}/temp/${id}.json?auth=${auth.token}`);

    dispatch({ type: 'UPDATE_CARD', payload: id });
  };


  function=(val)=>{
    console.log('function 0000')
    console.log(val)
  }
  handleProjectStatus = (projectStatus) =>{
    console.log('----------- projectStatus  -----------')
    console.log(projectStatus)
    if(!projectStatus){

      return(<Label color='teal' ribbon='right'style={{marginRight:"150px"}} > Draft </Label>)
    }
    else{
      return(<Label color='black' ribbon='right'style={{marginRight:"150px"}} > Project Completed </Label>)
    }
  }

  
  render() {
    const { item, image, text, heading, id, description} = this.props;
    console.log('-------- Cards.js   projectCompleted ----------')
    // console.log(item.projectCompleted)
    return (
      <Consumer>
        {value => {
          const { dispatch, auth } = value;
          return (
            <Card style={{width:'20vh'}}>
     
              {/* <Image  src={image} wrapped ui={false} /> */}
              <Card.Content>
              {/* {this.handleProjectStatus(item.projectCompleted)}  */}
              {/* {this.handleProjectStatus()} */}
             
              <Image
               
                floated='left'
                size='mini'
                // src='https://react.semantic-ui.com/images/avatar/large/steve.jpg'
                src={physician03}
              />
              {/* {this.function(item.projectCompleted)} */}
              {/* <Label color='teal' ribbon='right'style={{marginRight:"150px"}} > Draft </Label> */}
                <Card.Header>{heading}</Card.Header>
                <Card.Meta  style={{marginTop:"10px"}}>
          <span className='date'>{item.description}</span>
                </Card.Meta>
                <Card.Description>
                {text}
                </Card.Description>
              </Card.Content>
              <Card.Content extra>
                <a>
                  <Icon name='user' />
                  3 Members
                </a>
              </Card.Content>

              <Button
                    className="btn btn-warning w-75 mr-1"
                    onClick={() => this.onDeleteClick(id, dispatch, auth)}>
                    <span>
                      <i className="far fa-trash-alt" />
                    </span>{' '}
                    Remove
                  </Button>


                  <p>Edit</p>
                  <Link to={`/cardlist/card/edit/${id}`} className="btn btn-success w-25">
                    <span>
                      <i className="fas fa-edit" /> <p>Edit</p>
                    </span>
                  </Link>
                  {/* <br></br> */}
                  {/* <p>Edit 2</p>
                  <Link to={`/cardlist/card/edit2/${id}`} className="btn btn-success w-25">
                    <span>
                      <i className="fas fa-edit" /> <p>Edit 2</p>
                    </span>
                  </Link> */}

                  <Link to={`/cardlist/card/edit/${id}`} className="btn btn-success w-25">
          
                  <button
                    className="btn btn-warning w-75 mr-1"
                    onClick={() => this.onGetClick2(id, dispatch, auth)}>
                    <span>
                    <i className="fas fa-edit" /> <p>Edit</p>
                    </span>{' '}
                    
                  </button>
                  </Link>

                  <Card.Content extra style={{background:"black", color: "white"}}>
                    <p>4 images</p>
                    </Card.Content>


            </Card>

   
          );
        }}
      </Consumer>
    );
  }
}




// <Card>
// <Card.Content>
//   <Image
//     floated='right'
//     size='mini'
//     src='https://react.semantic-ui.com/images/avatar/large/steve.jpg'
//   />
//   <Card.Header>Steve Sanders</Card.Header>
//   <Card.Meta>Friends of Elliot</Card.Meta>
//   <Card.Description>
//     Steve wants to add you to the group <strong>best friends</strong>
//   </Card.Description>
// </Card.Content>
// <Card.Content extra>
//   <div className='ui two buttons'>
//     <Button basic color='green'>
//       Approve
//     </Button>
//     <Button basic color='red'>
//       Decline
//     </Button>
//   </div>
// </Card.Content>
// </Card>